import { autoinject, bindingMode, customElement, DOM } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { AutocompleteOptions } from 'framework/html_behaviors/af-autocomplete';
import { GroupBase } from 'support/base_classes/group-base';

@autoinject
@customElement('bs-form-lookup')
export class FormLookup extends GroupBase {
  @bindable placeholder = '';
  @bindable({ defaultBindingMode: bindingMode.twoWay }) value: string = null;
  @bindable({ defaultBindingMode: bindingMode.twoWay }) item: unknown = null;
  @bindable options: AutocompleteOptions | unknown[];
  @bindable valuePath = '';
  @bindable stickMode = false;
  @bindable templatePath: string = null;
  @bindable controlClass = '';
  @bindable disabled = false;
  @bindable maxlength = 524288;
  @bindable({ defaultBindingMode: bindingMode.twoWay }) hasfocus = false;
  @bindable tooltip = '';

  private showLoading = false;
  private showEmptyResult = false;
  constructor(private element: Element) {
    super();
  }

  blur() {
    this.element.dispatchEvent(DOM.createCustomEvent('blur'));
  }

  attached() {
    this.element.addEventListener(
      "af-autocomplete:loadingChanged",
      (value: CustomEvent) => {
        this.showLoading = value.detail;
      }
    );

    this.element.addEventListener(
      "af-autocomplete:dispatchEmptyResultsEvent",
      (value: CustomEvent) => {
        this.showEmptyResult = value.detail;
      }
    );
  }

  detached() {
    this.element.removeEventListener(
      "af-autocomplete:loadingChanged",
      (value: CustomEvent) => ({})
    );

    this.element.removeEventListener(
      "af-autocomplete:dispatchEmptyResultsEvent",
      (value: CustomEvent) => ({})
    );
  }
}
